module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAWklEQVQ4jWOgBWAEmTlz5sz/1DI7PT2dkQXGKe/4xIihgkTQWcEHdhwTmrb/eDA/HjkUn6IbShUwaugQMZQFjU8orRKVlkfT6aihVAY0SadwQ2EF7OAEDAwMAP35JkKzXhErAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/icon/icon_view4.png
// module id = MBFj
// module chunks = 3